import { Card, CardContent, CardHeader, CardTitle } from '@travellegacy/nexops-design-system';
import { LayoutDashboard } from 'lucide-react';

export default function MainDashboard() {
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h1 className="text-3xl font-bold text-foreground">Dashboard Principal</h1>
        <p className="text-muted-foreground mt-1">Visão geral do sistema</p>
      </div>

      {/* Placeholder Content */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle>Bem-vindo</CardTitle>
              <LayoutDashboard className="h-5 w-5 text-muted-foreground" />
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Este é o dashboard principal do sistema. O conteúdo será adicionado em breve.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
